import { render } from "./province-create.vue?vue&type=template&id=7753fbaa"
import script from "./province-create.vue?vue&type=script&lang=js"
export * from "./province-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__